import { rei } from "@/services/api"
import store from "@/store"

class EnderecosService {
  static getAddressByCEP (cep) {
    return fetch(`https://viacep.com.br/ws/${cep}/json`).then(res => res.json())
  }

  static getCitiesByState (state) {
    try {
      return fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${state}/municipios`)
        .then(res => res.json())
    } catch (e) {
      console.error('Erro ao consumir api de dados do ibge', e)
    }
  }

  static getLocation (latitude, longitude) {
    try {
      return fetch(`https://nominatim.openstreetmap.org/reverse.php?lat=${latitude}&lon=${longitude}&format=jsonv2`).then(res => res.json())
    } catch (e) {
      console.error('Erro ao consumir api de geolocalização', e)
    }
  }

  static storeAddress (params) {
    return rei.post(`endereco`, params).then(res => res.data)
  }

  static updateAddress (idEndereco, params) {
    return rei.put(`endereco/${idEndereco}`, { ...params }).then(res => res.data)
  }

  static addressStructure (address) {
    return {
      cep: address.cep,
      logradouro: address.logradouro,
      numero: address.numero,
      complemento: address.complemento,
      bairro: address.bairro,
      cidade: address.cidade,
      uf: address.uf
    }
  }

  static getStates () {
    return store.getters['repositorio/getStates']
  }

  static getCities (uf = null) {
    store.dispatch("repositorio/update")

    if (!uf) {
      return store.getters['repositorio/getCities']
    } else if (uf) {
      return store.getters['repositorio/getCities'].filter(city => city.uf == uf)
    }
  }
}

export default EnderecosService
